import React from 'react';
import { TextMarker } from '../../../../../../../_lib/components/TextMarker/TextMarker';

interface ListItemKeywordProps {
  title: string;
}

/**
 * Item in the listbox that features content like linked site headlines.
 */
export default function ListItemKeyword({ title }: ListItemKeywordProps) {
  return (
    <div className="combobox__list-page">
      <div className="combobox__list-nolink">
        <div className="combobox__filename">
          <TextMarker text={title} type="strong" />
        </div>
      </div>
    </div>
  );
}
